import { useQuery } from 'react-query';

import { APP_BACKEND_URL } from '@/config';
import axios from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';

export type SmsCredits = {
  '--': string;
  [key: string]: string;
};

export const getSmsCredits = ({ groupId = '' }: { groupId?: string }): Promise<SmsCredits> => {
  let params: any = {
    params: { isPublic: true },
  };

  if (groupId) {
    params = {
      params: { groupId: groupId, isPublic: true },
    };
  }
  return axios.get(`${APP_BACKEND_URL}payments-sms-credits`, params).then((response: any) => {
    return response;
  });
};

type QueryFnType = typeof getSmsCredits;

type UseSmsCreditsOptions = {
  groupId?: string;
  config?: QueryConfig<QueryFnType>;
};

export const useSmsCredits = ({ groupId = '', config }: UseSmsCreditsOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryFn: () => getSmsCredits({ groupId }),
    ...config,
  });
};
